import React, { useState, useEffect } from 'react';
import IsLoadingHOC from '../../Components/IsLoadingHOC';
import IsLoggedinHOC from '../../Components/IsLoggedinHOC';
import { useParams } from 'react-router-dom';
import UserInfomation from './UserInfomation';
import ShopInfomation from './ShopInfomation';
import ShopOtherInfomation from './ShopOtherInfomation';
import { useDispatch, useSelector } from 'react-redux';
import SocialLink from './SocialLink';
import OpeningHours from './OpeningHours';
import ShopImage from './ShopImage';
import Maqsam from './Maqsam';
import ShopOterImages from './ShopOterImages';
import { getCities } from '../../Redux/action/City';
import { saveCityData } from '../../Redux/action/App';
import { toast } from 'react-toastify';



function AddNewShop(props) {
    const { setLoading } = props
    const params = useParams()
    const dispatch = useDispatch()
    const { form_step } = useSelector(state => state.shop)
    const [searchParams] = useState({ id: "", name: "" })
    const [sorting] = useState({ order_in: -1, order_by: "_created_at" })

    useEffect(() => {
        getCitiesData()
    }, [])

    const getCitiesData = async () => {
        const payload = {
            search: { ...searchParams },
            shorting: { order_in: sorting.order_in, order_by: sorting.order_by },
        }
        setLoading(true)
        await dispatch(getCities(payload))
            .then(
                response => {
                    setLoading(false);
                    if (response.status === "1") {
                        const cityData = []
                        const resData = response.data.cities
                        resData.map(item =>
                            cityData.push({ value: item._id, label: item.name })
                        )
                        dispatch(saveCityData(cityData))
                    } else {
                        toast.error(response.data.error[0])
                    }
                },
                (error) => {
                    setLoading(false);
                    toast.error(error.response.data?.message)
                }
            )
    }

    return (
        <div className="content-wrapper">
            <div className="content-header main_breadcrumb_top">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Create a new Shop {params.id && 'Branch'}</h1>
                        </div>
                        {/* <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><Link to = "/">Home</Link></li>
                                <li className="breadcrumb-item active">Shops</li>
                                <li className="breadcrumb-item active">Create</li>
                            </ol>
                        </div> */}
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary card-tabs">
                                <div className="card-header p-0 pt-1">
                                    <ul className="nav nav-tabs" >
                                        <li className="nav-item">
                                            <span className={`nav-link ${form_step === "USER_INFO" && "active"}`} >Shop User Info</span>
                                        </li>
                                        <li className="nav-item">
                                            <span className={`nav-link ${form_step === "SHOP_INFO" && "active"}`}>Shop Info</span>
                                        </li>
                                        <li className="nav-item">
                                            <span className={`nav-link ${form_step === "SHOP_OTHER_INFO" && "active"}`} >Shop Other Info</span>
                                        </li>
                                        <li className="nav-item">
                                            <span className={`nav-link ${form_step === "SOCIAL_LINK" && "active"}`}>Social Links</span>
                                        </li>
                                        <li className="nav-item">
                                            <span className={`nav-link ${form_step === "OPENING_HOURS" && "active"}`} >Opening Hours</span>
                                        </li>
                                        <li className="nav-item">
                                            <span className={`nav-link ${form_step === "SHOP_IMAGE" && "active"}`} >Shop Images Links</span>
                                        </li>
                                        <li className="nav-item">
                                            <span className={`nav-link ${form_step === "SHOP_OTHER_IMAGE" && "active"}`} >Other Images Links</span>
                                        </li>
                                        <li className="nav-item">
                                            <span className={`nav-link ${form_step === "MAQSAM" && "active"}`} >Maqsam</span>
                                        </li>
                                    </ul>
                                </div>
                                {form_step === "USER_INFO" && <UserInfomation />}
                                {form_step === "SHOP_INFO" && <ShopInfomation />}
                                {form_step === "SHOP_OTHER_INFO" && <ShopOtherInfomation />}
                                {form_step === "SOCIAL_LINK" && <SocialLink />}
                                {form_step === "OPENING_HOURS" && <OpeningHours />}
                                {form_step === "SHOP_IMAGE" && <ShopImage />}
                                {form_step === "SHOP_OTHER_IMAGE" && <ShopOterImages />}
                                {form_step === "MAQSAM" && <Maqsam />}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
export default IsLoadingHOC(IsLoggedinHOC(AddNewShop))